import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";


import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  PieChart,
  Pie,
  Cell,
  LineChart,
  Line,
  ResponsiveContainer,
  Legend,
} from "recharts";
import "./AdminDashboard.css";
import CasesTable from "./CasesTable";
// import RequestTable from "./RequestTable";

const initialStats = {
  totalDonors: 0,
  totalReceivers: 0,
  registeredUsers: 0,
  bloodSamplesCollected: 0,
  bloodSamplesDonated: 0,
  siteTraffic: 0,
};

const trafficData = [
  { name: "Week 1", visits: 0 },
  { name: "Week 2", visits: 0 },
  { name: "Week 3", visits: 0 },
  { name: "Week 4", visits: 0 },
];

const bloodGroupDataInitial = [
  { name: "A+", value: 0 },
  { name: "B+", value: 0 },
  { name: "O+", value: 0 },
  { name: "AB+", value: 0 },
  { name: "A-", value: 0 },
  { name: "B-", value: 0 },
  { name: "O-", value: 0 },
  { name: "AB-", value: 0 },
];

const COLORS = [
  "#fd5f17",
  "#004eaf",
  "#00c49f",
  "#ffbb28",
  "#ff8042",
  "#8884d8",
  "#8dd1e1",
  "#a4de6c",
];

const bloodCompatibility = {
  "A+": { receive: ["O+", "O-", "A+", "A-"], donate: ["A+", "AB+"] },
  "O+": { receive: ["O+", "O-"], donate: ["A+", "B+", "O+", "AB+"] },
  "B+": { receive: ["O+", "O-", "B+", "B-"], donate: ["B+", "AB+"] },
  "AB+": {
    receive: ["A+", "B+", "O+", "AB+", "A-", "B-", "O-", "AB-"],
    donate: ["AB+"],
  },
  "A-": { receive: ["O-", "A-"], donate: ["A+", "A-", "AB+", "AB-"] },
  "O-": {
    receive: ["O-"],
    donate: ["A+", "B+", "O+", "AB+", "A-", "B-", "O-", "AB-"],
  },
  "B-": { receive: ["O-", "B-"], donate: ["B+", "B-", "AB+", "AB-"] },
  "AB-": { receive: ["A-", "B-", "O-", "AB-"], donate: ["AB+", "AB-"] },
};

const locations = [
  "Shimla",
  "Mandi",
  "Dharamshala",
  "Solan",
  "Chamba",
  "Una",
  "Kullu",
  "Bilaspur",
  "Hamirpur",
  "Chandigarh",
  "Baddi",
];

// function Sidebar({ onSelect }) {
//   return (
//     <div className="sidebar">
//       <h2>Admin Panel</h2>
//       <ul>
//         <li onClick={() => onSelect("dashboard")}>Dashboard</li>
//         <li onClick={() => onSelect("bloodUnits")}>Blood Units</li>
//         <li onClick={() => onSelect("registrations")}>Registrations</li>
//         <li onClick={() => onSelect("newUsers")}>Payment Gateway</li>
//       </ul>
//       <button
//         className="logout-button"
//         onClick={function () {
//           sessionStorage.removeItem("isAdmin");
//           window.location.href = "/admin/login";
//         }}
//       >
//         Logout
//       </button>
//     </div>
//   );
// }
function Sidebar({ onSelect }) {
  const navigate = useNavigate();

  return (
    <div className="sidebar">
      <h2>Admin Panel</h2>
      <ul>
        <li onClick={() => onSelect("dashboard")}>Dashboard</li>
        <li onClick={() => onSelect("bloodUnits")}>Blood Units</li>
        <li onClick={() => onSelect("registrations")}>Registrations</li>
        {/* <li onClick={() => onSelect("newUsers")}>Payment Gateway</li> */}
        <li onClick={() => onSelect("addCase")}>Add Case</li>
        </ul>
      <button
        className="logout-button"
        onClick={function () {
          sessionStorage.removeItem("isAdmin");
          sessionStorage.removeItem("token");
          navigate("/admin/login");
        }}
      >
        Logout
      </button>
    </div>
  );
}

function DashboardSection({ stats, bloodGroupData }) {
  return (
    <div className="main-content">
      <h2 className="main-heading">Admin Dashboard</h2>

      <div className="stats-grid">
        {Object.entries(stats).map(([key, value], idx) => (
          <div key={idx} className="stat-card">
            <h3>
              {key
                .replace(/([A-Z])/g, " $1")
                .replace(/^./, (str) => str.toUpperCase())}
            </h3>
            <p>{value}</p>
          </div>
        ))}
      </div>

      <div className="charts-grid">
        <div className="chart-box">
          <h3 className="red-text">Website Traffic (Weekly)</h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={trafficData}>
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="visits" fill="#cc3c3c" radius={[5, 5, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div className="chart-box">
          <h3 className="red-text">Blood Group Distribution</h3>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={bloodGroupData}
                dataKey="value"
                nameKey="name"
                outerRadius={100}
                label
              >
                {bloodGroupData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="chart-box">
        <h3 className="red-text">Monthly Blood Collection Trend</h3>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={trafficData}>
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line
              type="monotone"
              dataKey="visits"
              stroke="#b71c1c"
              strokeWidth={3}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

function BloodUnitsSection({ users }) {
  const [selectedGroup, setSelectedGroup] = useState("A+");
  const [selectedLocation, setSelectedLocation] = useState("All");

  const filteredUsers = users.filter(
    (user) =>
      user.bloodGroup === selectedGroup &&
      (selectedLocation === "All" ||
        user.address
          ?.toLowerCase()
          .includes(selectedLocation.trim().toLowerCase()))
  );

  const selected = bloodCompatibility[selectedGroup];

  return (
    <div className="main-content">
      <div className="section-content blood-compatibility-section">
        <h2 className="centered-heading">Select your Blood Group</h2>
        <div className="centered-buttons">
          {Object.keys(bloodCompatibility).map((group) => (
            <button
              key={group}
              onClick={() => setSelectedGroup(group)}
              className={`blood-type-button ${
                selectedGroup === group ? "selected" : ""
              }`}
            >
              {group}
            </button>
          ))}
        </div>

        <div className="centered-dropdown">
          <label htmlFor="location-select">Filter by Location:</label>
          <select
            id="location-select"
            onChange={(e) => setSelectedLocation(e.target.value)}
          >
            <option value="All">All</option>
            {locations.map((loc, idx) => (
              <option key={idx} value={loc}>
                {loc}
              </option>
            ))}
          </select>
        </div>

        <div className="blood-info-boxes">
          <div className="blood-box receive-box">
            <h3>🩸 You can take from</h3>
            <p>{selected.receive.join(", ")}</p>
          </div>
          <div className="blood-box donate-box">
            <h3>🎁 You can give to</h3>
            <p>{selected.donate.join(", ")}</p>
          </div>
        </div>

        <div className="blood-users-table" style={{ overflowX: "auto" }}>
          <h3>
            Users with Blood Group <strong>{selectedGroup}</strong>{" "}
            {selectedLocation !== "All" && <>from {selectedLocation}</>}
          </h3>
          <table>
            <thead>
              <tr>
                <th>Sr No.</th>
                <th>Name</th>
                <th>Blood Group</th>
                <th>Age</th>
                <th>Contact</th>
                <th>Location</th>
                <th>Type</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.map((user, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{user.fullName}</td>
                  <td>{user.bloodGroup}</td>
                  <td>{user.age}</td>
                  <td>{user.mobile}</td>
                  <td>{user.address}</td>
                  <td>{user.type}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

function RegistrationsSection({ users }) {
  return (
    <div className="main-content">
      <div className="section-content">
        <h2 className="red-text">Registrations</h2>
        <div className="blood-users-table" style={{ overflowX: "auto" }}>
          <table>
            <thead>
              <tr>
                <th>Sr No.</th>
                <th>Name</th>
                <th>Blood Group</th>
                <th>Age</th>
                <th>Contact</th>
                <th>Location</th>
                <th>Type</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{user.fullName}</td>
                  <td>{user.bloodGroup}</td>
                  <td>{user.age}</td>
                  <td>{user.mobile}</td>
                  <td>{user.address}</td>
                  <td>{user.type}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

function NewUsersSection() {
  return (
    <div className="main-content">
      <div className="section-content">
        <h2 className="red-text">Payment Status</h2>
        <p>
          This section shows newly registered users and their payment status.
        </p>
        <h2>Coming Soon...</h2>
      </div>
    </div>
  );
}
// function AddCase() {
  
//  <RequestTable />
  
// }

export default function AdminDashboard() {
  const [section, setSection] = useState("dashboard");
  const [users, setUsers] = useState([]);
  const [stats, setStats] = useState(initialStats);
  const [bloodGroupData, setBloodGroupData] = useState(bloodGroupDataInitial);
  const navigate = useNavigate(); // ✅ You already have this probably, if not add it here

  useEffect(() => {
    const isAdmin = sessionStorage.getItem("isAdmin");
    if (!isAdmin) {
      navigate("/admin/login");
    }
  }, [navigate]);

  useEffect(() => {
    const updatedStats = {
      totalDonors: users.filter((u) => u.type?.toLowerCase() === "donor")
        .length,
      totalReceivers: users.filter((u) => u.type?.toLowerCase() === "receiver")
        .length,
      registeredUsers: users.length,
      bloodSamplesCollected: users.length,
      bloodSamplesDonated: Math.floor(users.length * 0.6),
      siteTraffic: 2000 + users.length * 20,
    };

    const groupCount = {};
    bloodGroupDataInitial.forEach((g) => (groupCount[g.name] = 0));
    users.forEach((u) => (groupCount[u.bloodGroup] += 1));
    const updatedGroupData = bloodGroupDataInitial.map((g) => ({
      name: g.name,
      value: groupCount[g.name],
    }));

    setStats(updatedStats);
    setBloodGroupData(updatedGroupData);
  }, [users]);

  useEffect(() => {
    const fetchUsers = async () => {
      const token = sessionStorage.getItem("token");

      if (!token) {
        console.warn("🔐 No token found, skipping fetch.");
        return;
      }

      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/donations`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = await res.json();

        if (!res.ok) {
          console.error("🔐 Server response:", data);
          throw new Error("Unauthorized or failed to fetch data");
        }

        setUsers(data);
      } catch (error) {
        console.error("❌ Error fetching users:", error);
      }
    };

    fetchUsers();
  }, []);

  return (
    <div className="admin-dashboard">
      <Sidebar onSelect={setSection} />
      {section === "dashboard" && (
        <DashboardSection stats={stats} bloodGroupData={bloodGroupData} />
      )}
      {section === "bloodUnits" && <BloodUnitsSection users={users} />}
      {section === "registrations" && <RegistrationsSection users={users} />}
      {section === "newUsers" && <NewUsersSection />}
      {section === "addCase" && <CasesTable />}
    </div>
  );
}



// function RequestTable() {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [newRequest, setNewRequest] = useState({
//     patientName: "",
//     hospitalName: "",
//     bloodGroup: "",
//     urgencyLevel: "",
//     contactInfo: "",
//     additionalNotes: "",
//   });

//   const { requests, setRequests } = useContext(RequestContext);
//   const [editingRequest, setEditingRequest] = useState(null);
//   const [showAddForm, setShowAddForm] = useState(false);

//   const handleAddRequest = () => {
//     setRequests([...requests, { ...newRequest, id: Date.now() }]);
//     setNewRequest({
//       patientName: "",
//       hospitalName: "",
//       bloodGroup: "",
//       urgencyLevel: "",
//       contactInfo: "",
//       additionalNotes: "",
//     });
//     setShowAddForm(false);
//   };

//   const handleEditRequest = () => {
//     setRequests(
//       requests.map((req) =>
//         req.id === editingRequest.id ? editingRequest : req
//       )
//     );
//     setEditingRequest(null);
//   };

//   const handleDeleteRequest = (id) => {
//     setRequests(requests.filter((req) => req.id !== id));
//   };

//   const getRowColor = (urgency) => {
//     if (urgency >= 4) return "high";
//     if (urgency === 3) return "medium";
//     return "low";
//   };

//   return (
//     <>
//       {showAddForm && (
//         <div className="form-container">
//           <div className="form">
//             <h3>Add New Request</h3>
//             <h4>Patient Name</h4>
//             <input
//               placeholder="Patient Name"
//               value={newRequest.patientName}
//               onChange={(e) =>
//                 setNewRequest({ ...newRequest, patientName: e.target.value })
//               }
//             />
//             <h4>Hospital Name</h4>
//             <input
//               placeholder="Hospital Name"
//               value={newRequest.hospitalName}
//               onChange={(e) =>
//                 setNewRequest({ ...newRequest, hospitalName: e.target.value })
//               }
//             />
//             <h4>Blood Group</h4>
//             <select
//               value={newRequest.bloodGroup}
//               onChange={(e) =>
//                 setNewRequest({ ...newRequest, bloodGroup: e.target.value })
//               }
//             >
//               <option value="">Select Blood Group</option>
//               <option value="A+">A+</option>
//               <option value="A-">A-</option>
//               <option value="B+">B+</option>
//               <option value="B-">B-</option>
//               <option value="O+">O+</option>
//               <option value="O-">O-</option>
//               <option value="AB+">AB+</option>
//               <option value="AB-">AB-</option>
//             </select>
//             <h4>Urgency Level</h4>
//             <input
//               type="number"
//               min={1}
//               max={5}
//               placeholder="Urgency Level (1-5)"
//               value={newRequest.urgencyLevel}
//               onChange={(e) =>
//                 setNewRequest({
//                   ...newRequest,
//                   urgencyLevel: parseInt(e.target.value),
//                 })
//               }
//             />
//             <h4>Contact Info</h4>
//             <input
//               placeholder="Contact Info"
//               type="tel"
//               value={newRequest.contactInfo}
//               onChange={(e) =>
//                 setNewRequest({ ...newRequest, contactInfo: e.target.value })
//               }
//             />
//             <h4>Additional Info</h4>
//             <textarea
//               placeholder="Additional Notes"
//               value={newRequest.additionalNotes}
//               onChange={(e) =>
//                 setNewRequest({
//                   ...newRequest,
//                   additionalNotes: e.target.value,
//                 })
//               }
//             />
//             <div className="form-button">
//               <button className="cancel" onClick={() => setShowAddForm(false)}>
//                 Cancel
//               </button>
//               <button className="add" onClick={handleAddRequest}>
//                 Add Request
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {editingRequest && (
//         <div className="form-container">
//           <div className="form">
//             <h3>Edit Request</h3>

//             <h4>Patient Name</h4>
//             <input
//               placeholder="Patient Name"
//               value={editingRequest.patientName}
//               onChange={(e) =>
//                 setEditingRequest({
//                   ...editingRequest,
//                   patientName: e.target.value,
//                 })
//               }
//             />

//             <h4>Hospital Name</h4>
//             <input
//               placeholder="Hospital Name"
//               value={editingRequest.hospitalName}
//               onChange={(e) =>
//                 setEditingRequest({
//                   ...editingRequest,
//                   hospitalName: e.target.value,
//                 })
//               }
//             />

//             <select
//               value={newRequest.bloodGroup}
//               onChange={(e) =>
//                 setNewRequest({ ...newRequest, bloodGroup: e.target.value })
//               }
//             >
//               <option value="">Select Blood Group</option>
//               <option value="A+">A+</option>
//               <option value="A-">A-</option>
//               <option value="B+">B+</option>
//               <option value="B-">B-</option>
//               <option value="O+">O+</option>
//               <option value="O-">O-</option>
//               <option value="AB+">AB+</option>
//               <option value="AB-">AB-</option>
//             </select>
//             <h4>Urgency Level</h4>
//             <input
//               type="number"
//               min={1}
//               max={5}
//               placeholder="Urgency Level (1-5)"
//               value={newRequest.urgencyLevel}
//               onChange={(e) =>
//                 setNewRequest({
//                   ...newRequest,
//                   urgencyLevel: parseInt(e.target.value),
//                 })
//               }
//             />

//             <h4>Contact Info</h4>
//             <input
//               placeholder="Contact Info"
//               value={editingRequest.contactInfo}
//               onChange={(e) =>
//                 setEditingRequest({
//                   ...editingRequest,
//                   contactInfo: e.target.value,
//                 })
//               }
//             />

//             <h4>Additional Info</h4>
//             <textarea
//               placeholder="Additional Notes"
//               value={editingRequest.additionalNotes}
//               onChange={(e) =>
//                 setEditingRequest({
//                   ...editingRequest,
//                   additionalNotes: e.target.value,
//                 })
//               }
//             />

//             <div className="form-button">
//               <button
//                 className="cancel"
//                 onClick={() => setEditingRequest(null)}
//               >
//                 Cancel
//               </button>
//               <button className="add" onClick={handleEditRequest}>
//                 Save
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//       <div className="request-container">
//         <div className="top-bar">
//           <h2>Urgent Help Requests</h2>
//           <div className="actions">
//             <input
//               type="search"
//               placeholder="Search requests..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//             <button onClick={() => setShowAddForm(true)}>Add Request</button>
//           </div>
//         </div>

//         <section className="table-section">
//           <table className="table-container">
//             <thead>
//               <tr>
//                 <th>No.</th>
//                 <th>Patient Name</th>
//                 <th>Hospital Name</th>
//                 <th>Blood Group</th>
//                 <th>Urgency</th>
//                 <th>Contact Info</th>
//                 <th>Additional Notes</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {requests.length === 0 ? (
//                 <tr>
//                   <td colSpan="8" style={{ textAlign: "center" }}>
//                     No requests found.
//                   </td>
//                 </tr>
//               ) : (
//                 requests.map((req, idx) => (
//                   <tr key={req.id} className={getRowColor(req.urgencyLevel)}>
//                     <td>{idx + 1}</td>
//                     <td>{req.patientName}</td>
//                     <td>{req.hospitalName}</td>
//                     <td>{req.bloodGroup}</td>
//                     <td>
//                       <span
//                         className={`urgency-dot ${getRowColor(
//                           req.urgencyLevel
//                         )}`}
//                       ></span>
//                       {req.urgencyLevel}
//                     </td>
//                     <td>{req.contactInfo}</td>
//                     <td>{req.additionalNotes}</td>
//                     <td>
//                       <Pencil
//                         className="pencil"
//                         onClick={() => setEditingRequest({ ...req })}
//                       />
//                       <Trash2
//                         className="trash"
//                         onClick={() => handleDeleteRequest(req.id)}
//                       />
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </section>
//       </div>
//     </>
//   );
// }
